import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { SocialFeedService } from '../social-feed/services/social-feed.service';
import { SocialPost } from '../social-feed/models/social-feed.model';

/**
 * One post on its own page (/social-post/:id) with its whole comment thread.
 * Notifications, search results and comment buttons lead here, and the link
 * can be shared (it only opens for people allowed to see the post).
 */
@Component({
  selector: 'app-social-post',
  templateUrl: './social-post.component.html',
  styleUrls: ['./social-post.component.scss'],
  standalone: false,
})
export class SocialPostComponent implements OnInit {
  postId = 0;
  post: SocialPost | null = null;
  loading = true;
  notFound = false;
  loadFailed = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private social: SocialFeedService,
    private cdr: ChangeDetectorRef,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.postId = Number(params.get('postId'));
      this.load();
    });
  }

  load(): void {
    this.loading = true;
    this.notFound = this.loadFailed = false;
    this.post = null;
    this.social.getPost(this.postId).subscribe({
      next: (post) => {
        this.post = post;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.notFound = err?.status === 404;
        this.loadFailed = !this.notFound;
        this.cdr.markForCheck();
      },
    });
  }

  back(): void {
    if (window.history.length > 1) this.location.back();
    else this.router.navigate(['/social-feed']);
  }

  /** Deleted here: there's nothing left to show. */
  onRemoved(): void {
    this.back();
  }
}
